import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 97D593C8-1C57-4597-AB1C-C6B487633BBD
 * name credit-card-minus
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-minus.svg
 * tags
 * - Banking 
 */
export const CreditCardMinusIcon = createSvgIcon(<><path d="M20 4H4C2.9 4 2 4.89 2 6V18C2 19.11 2.9 20 4 20H13.09C13.03 19.67 13 19.34 13 19C13 15.69 15.69 13 19 13C20.06 13 21.09 13.28 22 13.81V6C22 4.89 21.11 4 20 4M20 11H4V8H20M23 18V20H15V18H23Z" /></>, 'CreditCardMinusIcon');
export default CreditCardMinusIcon